import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import useStore from "../../store/store";
import style from "../../utils/style";
import userService from "../../services/user";
import {
  Button,
  Text,
  Password,
  Error,
  Success,
  LinkButton,
  FormatPhone,
} from "../../controls";
import PageHeading from "../../components/PageHeading";

function Signup() {
  const { setIsLoading, setIsLoggedIn, setToken, setUser, setCompany } =
    useStore((state) => state);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");

    if (!phone || !password || !name) {
      setErrorMessage(`All fields are required.`);
      return;
    }

    setIsLoading(true);
    userService
      .signup({ name, phone: phone.trim(), password })
      .then((result) => {
        if (result.error) {
          setErrorMessage(result.error);
          setIsLoading(false);
          return;
        }
        setErrorMessage("");
        setSuccessMessage(`Signup successful! Redirecting...`);
        setIsLoading(false);
        setIsLoggedIn(true);
        setToken(result.data.token);
        setUser(result.data.user);
        setCompany(result.data.company);
        navigate("/profile");
      });
  };

  return (
    <Grid container sx={style.container}>
      <Grid item xs={12} sx={style.authGrid}>
        <PageHeading text="Sign Up" mb="15px" />
        <Text label="Full name" value={name} onChange={setName} />
        <FormatPhone label="Phone" value={phone} onChange={setPhone} />
        <Password label="Password" value={password} onChange={setPassword} />
        <Button
          text="Create Account"
          onClick={handleSubmit}
          icon={<PersonAdd />}
          extraStyles={{ marginTop: 5 }}
        />
        <Error text={errorMessage} />
        <Success text={successMessage} />
        <LinkButton
          label="Already have account?"
          text="Sign in"
          to="/login"
          mt={15}
        />
      </Grid>
    </Grid>
  );
}

export default Signup;
